import { useNavigationPosition } from "@shared/lib/hooks";
import "./journal-banner.scss";
import { JournalBannerSectionFour } from "../journal-banner-section-four/journal-banner-section-four";
import { JournalBannerSectionOne } from "../journal-banner-section-one";
import { JournalBannerSectionThree } from "../journal-banner-section-three";
import { JournalBannerSectionTwo } from "../journal-banner-section-two";
import { JournalBannerTitle } from "../journal-banner-title";

export const JournalBanner = () => {
  const { isSectionOne, isSectionTwo, isSectionThree, isSectionFour, isTitle } =
    useNavigationPosition();

  if (isTitle) {
    return <JournalBannerTitle />;
  }

  if (isSectionOne) {
    return <JournalBannerSectionOne />;
  }

  if (isSectionTwo) {
    return <JournalBannerSectionTwo />;
  }

  if (isSectionThree) {
    return <JournalBannerSectionThree />;
  }

  if (isSectionFour) {
    return <JournalBannerSectionFour />;
  }

  return null;
};

